<template>
  <div class="user-agreement" @click.self="closeModal">
    <div class="agreement-modal">
      <div class="agreement-header">
      <h1>用户服务协议</h1>
      <p class="update-time">最后更新时间：2025年9月24日</p>
    </div>
    
    <div class="agreement-content">
      <section>
        <h2>1. 服务条款的接受</h2>
        <p>欢迎使用BIMer的AI助手服务！本协议是您与我们之间关于使用本服务的法律协议。通过访问或使用我们的服务，您同意受本协议条款的约束。如果您不同意本协议的任何条款，请不要使用我们的服务。</p>
      </section>

      <section>
        <h2>2. 服务描述</h2>
        <p>BIMer的AI助手是一个基于人工智能技术的建筑信息模型(BIM)辅助工具，提供建模助手、投标助手、BIM审查、BIM政策分析、BIM渲染等相关服务。我们致力于为用户提供专业、高效的AI辅助服务。</p>
      </section>

      <section>
        <h2>3. 用户注册与账户</h2>
        <p>3.1 用户需要注册账户才能使用我们的服务。注册时，您必须提供真实、准确、完整和最新的信息。</p>
        <p>3.2 您有责任维护账户信息的机密性，并对在您账户下发生的所有活动负责。</p>
        <p>3.3 如发现任何未经授权使用您账户的情况，请立即通知我们。</p>
      </section>

      <section>
        <h2>4. 用户行为规范</h2>
        <p>使用我们的服务时，您不得：</p>
        <ul>
          <li>上传、发布违法、有害、威胁、滥用、诽谤、淫秽或其他不当内容</li>
          <li>侵犯他人的知识产权或其他权利</li>
          <li>进行任何可能损害、禁用、过载或损坏我们服务的活动</li>
          <li>尝试未经授权访问我们的系统或其他用户的账户</li>
          <li>将服务用于任何非法目的或以任何非法方式使用</li>
        </ul>
      </section>

      <section>
        <h2>5. 知识产权</h2>
        <p>5.1 我们的服务及其所有内容、功能和特性（包括但不限于所有信息、软件、文本、显示、图像、视频和音频，以及设计、选择和排列）均为我们、我们的许可方或其他内容提供者所有。</p>
        <p>5.2 您上传或提交的内容仍归您所有，但您授予我们使用该内容来提供和改进服务的权利。</p>
        <p>5.3 未经明确许可，您不得复制、修改、分发、销售或出租我们服务的任何部分。</p>
      </section>

      <section>
        <h2>6. 隐私保护</h2>
        <p>6.1 我们重视您的隐私，将按照相关法律法规保护您的个人信息。</p>
        <p>6.2 我们收集的信息仅用于提供服务、改善用户体验和遵守法律要求。</p>
        <p>6.3 除非获得您的同意或法律要求，我们不会向第三方披露您的个人信息。</p>
      </section>

      <section>
        <h2>7. 免责声明</h2>
        <p>7.1 我们的服务按"现状"提供，不对服务的可用性、准确性、可靠性或完整性作任何明示或暗示的保证。</p>
        <p>7.2 我们不保证服务不会中断、无错误或完全安全。</p>
        <p>7.3 对于因使用我们服务而产生的任何直接、间接、特殊、偶然或后果性损害，我们概不负责。</p>
        <p>7.4 AI生成的内容仅供参考，用户应当根据实际情况进行判断和使用，我们不对AI输出结果的准确性承担责任。</p>
      </section>

      <section>
        <h2>8. 服务变更与终止</h2>
        <p>8.1 我们保留随时修改、暂停或终止服务的权利，恕不另行通知。</p>
        <p>8.2 如果您违反本协议，我们有权立即终止您的账户和服务访问权限。</p>
        <p>8.3 服务终止后，本协议中关于知识产权、免责声明、赔偿和争议解决的条款仍然有效。</p>
      </section>

      <section>
        <h2>9. 赔偿</h2>
        <p>您同意因您违反本协议或使用服务而产生的任何索赔、损失、责任、损害、费用和开支（包括合理的律师费），向我们进行赔偿并使我们免受损害。</p>
      </section>

      <section>
        <h2>10. 争议解决</h2>
        <p>10.1 本协议受中华人民共和国法律管辖。</p>
        <p>10.2 因本协议产生的争议，双方应首先通过友好协商解决。</p>
        <p>10.3 如协商不成，任何一方均可向有管辖权的人民法院提起诉讼。</p>
      </section>

      <section>
        <h2>11. 协议修改</h2>
        <p>我们保留随时修改本协议的权利。修改后的协议将在我们的网站上发布，并自发布之日起生效。继续使用我们的服务即表示您接受修改后的协议。</p>
      </section>

      <section>
        <h2>12. 联系我们</h2>
        <p>如果您对本协议有任何疑问或建议，请通过以下方式联系我们：</p>
        <p>邮箱：714283991@qq.com</p>
        <p>联系电话：15801772538</p>
      </section>
    </div>

      <div class="agreement-footer">
        <button @click="closeModal" class="back-button">返回</button>
        <button @click="acceptAgreement" class="accept-button">我已阅读并同意</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  methods: {
    closeModal() {
      this.$emit('close');
    },
    acceptAgreement() {
      // 发出用户同意协议的事件
      this.$emit('agreementAccepted');
    }
  }
}
</script>

<style scoped>
.user-agreement {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.agreement-modal {
  background: white;
  border-radius: 10px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.agreement-header {
  text-align: center;
  padding: 20px;
  border-bottom: 2px solid #007bff;
  flex-shrink: 0;
}

.agreement-header h1 {
  color: #333;
  font-size: 28px;
  margin-bottom: 10px;
}

.update-time {
  color: #666;
  font-size: 14px;
}

.agreement-content {
  line-height: 1.6;
  color: #333;
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.agreement-content section {
  margin-bottom: 25px;
}

.agreement-content h2 {
  color: #007bff;
  font-size: 18px;
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 4px solid #007bff;
}

.agreement-content p {
  margin-bottom: 10px;
  text-align: justify;
}

.agreement-content ul {
  margin-left: 20px;
  margin-bottom: 10px;
}

.agreement-content li {
  margin-bottom: 5px;
}

.agreement-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-shrink: 0;
}

.back-button, .accept-button {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-button {
  background-color: #6c757d;
  color: white;
}

.back-button:hover {
  background-color: #545b62;
}

.accept-button {
  background-color: #007bff;
  color: white;
  flex: 1;
}

.accept-button:hover {
  background-color: #0056b3;
}

/* 手机端样式 */
@media (max-width: 768px) {
  .user-agreement {
    padding: 10px;
  }
  
  .agreement-modal {
    max-height: 95vh;
    margin: 0;
  }
  
  .agreement-header {
    padding: 15px;
  }
  
  .agreement-header h1 {
    font-size: 20px;
  }
  
  .agreement-content {
    padding: 15px;
  }
  
  .agreement-content h2 {
    font-size: 16px;
  }
  
  .agreement-content p {
    font-size: 14px;
  }
  
  .agreement-footer {
    flex-direction: column;
    padding: 15px;
  }
  
  .back-button, .accept-button {
    width: 100%;
    padding: 15px;
    font-size: 16px;
  }
}
</style>